import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import Spinner from 'react-spinkit';
import { NewLegalDocumentSlider } from './NewLegalDocumentSlider';
import { Grid, Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import { LegalDocument } from './LegalDocument';
import Animated from 'components/Animated';
import { Button } from 'components/Button';
import Text from 'components/Text';

import { LegalDocumentTypeEnum } from './enum';
import { useLegalDocumentContext } from 'contexts/LegalDocument';
import { LegalDocumentProps, LegalDocumentsProps } from './interface';
import { EnumUserType } from 'models/User';

import Slider from 'react-slick';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.scss';

export const LegalDocuments: React.FC<LegalDocumentsProps> = (props) => {

  const { legalDocumentsAttachments } = props;
  const [documents, setDocuments] = useState<LegalDocumentProps[]>([]);

  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const { loadingLegalDocument } = useLegalDocumentContext();

  const DOCUMENT_MAX_SHOW_SLIDER = user?.userType === EnumUserType.EMPLOYEE ? 6 : 3;

  const settings = {
    dots: false,
    infinite: true,
    speed: 100,
    slidesToShow: DOCUMENT_MAX_SHOW_SLIDER,
    slidesToScroll: 1,
    className: "legal-documents-wrapper",
    adaptiveHeight: true
  };

  const SHOW_MAIN_LEGAL_DOCUMENT = !loadingLegalDocument && documents.length > 0 && documents.length <= DOCUMENT_MAX_SHOW_SLIDER;
  const SHOW_LEGAL_DOCUMENT_WITH_SLIDER = !loadingLegalDocument && documents.length > DOCUMENT_MAX_SHOW_SLIDER;

  useEffect(() => {
    const updatedDocuments = (legalDocumentsAttachments ?? []).map((document) => {
      if (document.legalDocumentType === LegalDocumentTypeEnum.OTHER && document.periodValidity) {
        return { ...document, periodValidity: "" };
      }
      return document;
    });

    const sortedDocuments = updatedDocuments.sort((a, b) => a.legalDocumentType - b.legalDocumentType);

    setDocuments(sortedDocuments);
  }, [legalDocumentsAttachments]);

  return (
    <Column className="flex-1 mt-5">
      <Row className="mb-2 mt-md-5 grid-gap-4">
        <Text className="color-primary font-bold" size={24}>
          Documentos Legais
        </Text>

        {/*<Row className="flex-1 justify-between mb-3">
          <Button
            onClick={() =>
              dispatch({
                type: 'OPEN_SLIDER',
                data: {
                  title: 'Incluir Documentos',
                  content: NewLegalDocumentSlider,
                },
              })
            }
          >
            <Text className="color-secondary font-bold" size={14}>
              + Incluir Documentos
            </Text>
          </Button>
        </Row>
        */}
      </Row>

      <Visibility visible={loadingLegalDocument}>
        <Row className="align-center justify-center flex-1 mt-5">
          <Spinner
            fadeIn="none"
            name="circle"
            color="#0E4C54"
            style={{
              height: 30,
              width: 30
            }}
          />
        </Row>
      </Visibility>

      <Visibility visible={SHOW_MAIN_LEGAL_DOCUMENT}>
        <Column className="flex-1 align-items-start relative">
          <Grid
            className="grid-legal-documents"
            colsGap="10px"
            rows={1}
          >
            {documents.map((document, index) => (
              <LegalDocument key={index} document={document} />
            ))}
          </Grid>
        </Column>
      </Visibility>

      <Visibility visible={SHOW_LEGAL_DOCUMENT_WITH_SLIDER}>
        <Animated
          show
          animationIn="slideInUp"
          animationInDelay="faster"
          animationOut="none"
          animationOutDelay="faster"
        >
          <Column>
            <div
              className="bg-white px-3"
              style={{ borderRadius: "10px 10px 0 0" }}
            >

              <Slider {...settings}>
                {documents.map((document, index) => (
                  <LegalDocument key={index} document={document} />
                ))}
              </Slider>

            </div>
          </Column>
        </Animated>
      </Visibility>

      <Visibility visible={documents.length === 0}>
        <Column className="flex-1 align-items-start relative">
          <Text>Nenhum documento encontrado</Text>
        </Column>
      </Visibility>
    </Column>
  );
};